<template>
  <div style="width: 80% !important;">
    <b-sidebar v-if="Object.keys(ses).length !== 0"  id="profile-sidebar-right" :title="ses.name" right shadow  style="width: 80% !important;background-color: #fff !important;">
      <div class="px-3 py-2">
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">EP Type</strong>
              <span v-for="(ep_type, index) in ses.ep_types" :key="index">- {{ ep_type.ep_type_desc}} <br> </span>
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Form Number</strong>
              {{ ses.form_no }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">Mobile Number</strong>
                {{ ses.mobile }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">
                  <span v-if="ses.id_type === 'N'">National ID</span>
                  <span v-if="ses.id_type === 'P'">Passport No.</span>
                  <span v-if="ses.id_type === 'B'">Birth Certificate No.</span>
                </strong>
                {{ ses.nid }}
              </p>
            </div>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">Household Number</strong>
              {{ ses.household_number }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">1.1 Name Household Head</strong>
              {{ ses.name }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">
                  <span v-if="ses.father_hus_type === 'F'">1.2 Fathers Name</span>
                  <span v-if="ses.father_hus_type === 'H'">1.2 Husband Name</span>
                  <span v-if="ses.father_hus_type === 'S'">1.2 Spouse Name</span>
                </strong>
                {{ ses.father_husband_name }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.3 Mothers Name</strong>
                {{ ses.mother_name }}
              </p>
            </div>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.4 Date Of Birth</strong>
              {{ ses.dob }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Gender</strong>
              {{ ses.gender.gender_desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.5 Village</strong>
                {{ ses.present_address != null ? ses.present_address.village : ses.village.village_desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.6 Mouza</strong>
              {{ ses.present_address != null ? ses.present_address.mouza : ses.mouza.mouza_desc }}
            </p>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.7 Union</strong>
                {{ ses.present_address != null ? ses.present_address.union_ward : ses.union.union_desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">1.8 Upazila</strong>
              {{ ses.present_address != null ? ses.present_address.upazila : ses.upazila.upazila_desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.9 District</strong>
                {{ ses.present_address != null ? ses.present_address.district : ses.district.district_desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">Division</strong>
                {{ ses.present_address != null ? ses.present_address.division : ses.division.division_desc  }}
              </p>
            </div>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">1.10 Main Occupation</strong>
              {{ ses.occupation.occupation_desc }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.11 Religion</strong>
                {{ ses.religion.religion_desc }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.12 Ethnic(Mention the Group) </strong>
              {{ ses.ethnic }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">1.13 Family/Institution Yearly Income</strong>
              {{ ses.yearly_income }}
            </p>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">1.14 Family/Institution Yearly Expenditure</strong>
              {{ ses.yearly_exp }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">1.15 Name of Institution Secretary</strong>
                {{ ses.institution_sec }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">RP Serial</strong>
                {{ ses.rp_serial }}
              </p>
            </div>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Appointment By</strong>
              {{ ses.appointment_by }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">Appointment Date</strong>
              {{ ses.appointment_date }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">Survey Conducted By</strong>
                {{ ses.survey_worker ? ses.survey_worker.name : '' }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150">
              <strong class="d-block text-dark pb-1">Survey Conducted Date</strong>
              {{ ses.survey_date ? ses.survey_date : ''}}
            </p>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">Area Manager</strong>
              {{ ses.area_manager ? ses.area_manager.name : '' }}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-3">
            <div class="media text-muted">
              <p class="media-body pb-2 mb-0 medium lh-150">
                <strong class="d-block text-dark pb-1">Area Manager Date</strong>
                {{ ses.area_manager_date ? ses.area_manager_date : '' }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="ses_additional.own_land" class="row pb-1">
          <div class="col-md-6 col-sm-6 col-lg-3">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">3.1 Do you have own land?</strong>
              {{ ses_additional.own_land }}
            </p>
          </div>
        </div>
        <div v-if="ses_additional.connections" class="row pb-1">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">9. For implementing the project what will be the affect in your residence/commercial structure for the following connection.</strong>
              <span v-for="(connection, index) in ses_additional.connections" :key="index">- {{ connection.connection_desc }} <br> </span>
            </p>
          </div>
        </div>
        <div class="row pb-1">
          <div v-if="ses_additional.land_ownership_type" class="col-md-6 col-sm-6 col-lg-4">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">10.1.1 Land owner</strong>
              {{ ses_additional.land_ownership_type.land_ownership_type_desc }}
            </p>
          </div>
          <div v-if="ses_additional.category_loss" class="col-md-6 col-sm-6 col-lg-4">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">10.1.2 Category of losses</strong>
              {{ ses_additional.category_loss }}
            </p>
          </div>
          <div v-if="ses_additional.alternative_land" class="col-md-6 col-sm-6 col-lg-4">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">10.1.3 Do you have any other alternative land except consumable land?</strong>
              {{ ses_additional.alternative_land }}
            </p>
          </div>
        </div>
        <div v-if="ses_additional.land_buy" class="row pb-1">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
              <strong class="d-block text-dark pb-1">11. Do you purchased any land with the cash you received in compensation?</strong>
              {{ ses_additional.land_buy }}
            </p>
          </div>
        </div>
        <router-link :to="{ name: 'sesView',params: { ses_id: ses.id }}" tag="a" target="_blank">View Full SES</router-link>
      </div>
    </b-sidebar>
<!--    <h5 v-else class="text-center text-secondary">-->
<!--      No Data Found-->
<!--    </h5>-->
  </div>
</template>
<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EntitlementPersonLayout from './layout'
import http from "@state/http";
import substr_replace from "@views/asset/js/substr_replace";

export default {
  page: {
    title: 'Entitlement Person',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, EntitlementPersonLayout },
  data() {
    return {
      title: 'Entitlement Person Profile',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Entitlement Person Profile',
          active: true,
        },
      ],
      ses: {},
      ses_additional: {}
    }
  },
  mounted() {
    this.getEpProfile();
  },

  methods: {
    epModify(ep_id){
      var split_string = ep_id.toString()
      return substr_replace(split_string, '#', 5, 0)
    },
    getEpProfile() {
       let ses_id = this.$route.params.ses_id;
      http.get("api/entitlement-person/personal-information/" + ses_id).then(response => {
        if (!response.error) {
          this.ses = response.data.ses;
          response.data.ses_additional === "" || response.data.ses_additional === null ? "" : (this.ses_additional = response.data.ses_additional);
        }
      });
    }
  },
}
</script>
<style scoped>
.b-sidebar{
  width: 80% !important;
}
</style>